import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { ProgramWithLanding } from 'types/Program';
import { LandingPageFormsAvailability } from 'types/LandingPageFormsAvailability';
import Topbar from 'components/landingPages/components/Topbar';
import Footer from 'components/_common/Footer';
import UserDashboardSectionLink from './UserDashboardSectionLink';

interface LandingPageWrapperProps {
	programData: ProgramWithLanding;
	formsAvailability?: LandingPageFormsAvailability;
}

const LandingPageWrapper: FC<LandingPageWrapperProps> = ({
	programData,
	formsAvailability,
}: LandingPageWrapperProps) => {
	return (
		<div className="flex flex-column flex-1 h-full max-h-screen">
			<Topbar programData={programData} formsAvailability={formsAvailability} />

			<div className="flex-1 flex flex-column gap-4 h-full ">
				<div className="lp flex-1">
					<Outlet />
					<UserDashboardSectionLink />
				</div>
				<Footer />
			</div>
		</div>
	);
};

export default LandingPageWrapper;
